import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MoreHorizontal, Edit2, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Board } from "@/types/board";

interface BoardCardProps {
  board: Board;
  onEdit: (board: Board) => void;
  onDelete: (boardId: string) => void;
}

const BoardCard = ({ board, onEdit, onDelete }: BoardCardProps) => {
  return (
    <div className="group relative">
      <Link to={`/board/${board.id}`}>
        <Card className="h-32 cursor-pointer p-4 transition-all hover:border-blue-500 hover:shadow-md">
          <h3 className="font-medium text-gray-900">{board.title}</h3>
          <p className="mt-2 text-sm text-gray-600">
            Created {new Date(board.created_at || '').toLocaleDateString()}
          </p>
        </Card>
      </Link>
      <div className="absolute right-2 top-2">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="h-8 w-8">
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem onClick={() => onEdit(board)}>
              <Edit2 className="mr-2 h-4 w-4" />
              Edit
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onDelete(board.id)}>
              <Trash2 className="mr-2 h-4 w-4" />
              Delete
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};

export default BoardCard;